import { Ristorante } from "./Ristorante";

export default class Tavolo {
    id!: number;
    code!: string;
    nome!: string;
    posti!: number;
    externalId!: string;
    ristorante!: Ristorante;
    order!: number;

    static fromJson(json: any) {
        let result = new Tavolo();
        result.id = json.id;
        result.code = json.code;
        result.nome = json.nome;
        result.posti = json.posti;
        result.order = json.order;
        if (json.ristorante) {
            result.ristorante = Ristorante.fromJson(json.ristorante);
        }
        return result;
    }
}